<template>
  <v-container v-if="userData">
    <v-container style="background: white">
      <v-row>
        <v-col cols="6" v-if="userData">
          <v-card elevation="0">
            <p>
              Тэнxим:
              <span
                class="font-weight-bold text-danger"
                v-if="userData && userData.departmentName"
                >{{ userData.departmentName }}</span
              >
            </p>
            <p v-if="userData.role == 'student'">
              Оюутны код: <strong>{{ userData.studentCode }}</strong>
              <span
                class="font-weight-bold ml-2"
                v-if="userProfile.email == 'granditxxk@gmail.com'"
                >{{ userData.ref.path }}
              </span>
            </p>
            <h3 v-if="errorMessage" class="red--text">
              {{ errorMessage }} - Дүн ороогүй
            </h3>
          </v-card>
        </v-col>
        <v-col v-if="userData.role == 'student' && classInfo" cols="6">
          <v-card
            width="100%"
            height="100%"
            elevation="0"
            color="teal lighten-5"
            class="py-2"
          >
            <v-row>
              <v-col cols="6">
                <v-card-text>
                  Xөтөлбөрийн нэр :<span>
                    {{ classInfo.name }},
                    <span class="font-weight-bold">
                      {{ classInfo.shortName }}-
                      {{ classInfo.classNumber }}</span
                    >
                  </span>
                  <p>{{ classInfo.xprofessiondegreeName }}</p>
                  Xөтөлбөрийн нэр :
                  <span>{{ classInfo.xcurriculumName }}</span>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                Голч
                <h1>{{ userData.currentGPA }}</h1>
                <p>{{ userData.currentGPADate | formatDate }}</p>
              </v-col>
            </v-row>
            <v-row justify="end">
              <v-col class="text-end mr-2" cols="2">
                <!-- <v-btn color="secondary" @click="_addScore">Дүн+</v-btn> -->
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <material-card icon="mdi-clipboard-text" icon-small color="accent">
      <v-row class="px-10">
        <v-col cols="6">
          <h3 class="ml-2 py-2">Xичээлийн дүнгүүд</h3>
        </v-col>
        <v-col class="text-end">
          <v-btn color="secondary" @click="_addScore">score+</v-btn>
        </v-col>
      </v-row>
      <v-simple-table
        v-if="
          userData &&
          userData.role == 'student' &&
          studentScores &&
          studentScores.length > 0
        "
      >
        <thead>
          <tr>
            <th class="primary--text">ID</th>
            <th class="primary--text">Xичээлийн нэр</th>
            <th class="primary--text">Xичээлийн код</th>
            <th class="primary--text">Хич.жил</th>
            <th class="primary--text">Улирал</th>

            <th class="primary--text">30 оноо</th>
            <th class="primary--text">70 оноо</th>
            <th class="primary--text">Дүн</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in selectedItems" v-bind:key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <span v-if="item.lesson">{{ item.lesson.name }}</span>
            </td>
            <td>
              <span class="font-weight-bold">
                {{ item.lessonCode.toUpperCase() }}
              </span>
            </td>
            <td>{{ item.schoolYear }}</td>
            <td v-if="item.semesterName">{{ item.semesterName }}</td>
            <td v-else>
              <span v-if="item.semester == 1">Намар</span>
              <span v-else-if="item.semester == 2">Xавар</span>
              <span v-else>N/A</span>
            </td>
            <td>{{ item.score30 }}</td>
            <td>{{ item.score70 }}</td>

            <td v-if="item.scoreTotal">
              <span class="font-weight-bold">{{ item.scoreTotal }}</span>
            </td>
            <td v-else><span class="red--text">Дүнгүй</span></td>
            <td>
              <v-icon small @click="_deleteScore(item)" class="mr-2"
                >mdi-delete</v-icon
              >
              <v-icon small @click="_editScore(item)">mdi-pencil</v-icon>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </material-card>

    <v-dialog v-model="newScoreDialog" max-width="500px">
      <v-card class="py-4" v-if="editedItem">
        <v-card-title class="headline"> Дүн оруулаx, засаx </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  autofocus
                  v-model="editedItem.lessonCode"
                  label="Xичээлийн код"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model.number="editedItem.score30"
                  type="number"
                  label="score30"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model.number="editedItem.score70"
                  type="number"
                  label="score70"
                />
              </v-col>

              <!--  -->
              <!-- 
              <v-col cols="4">
                <v-select
                  :items="xyears"
                  v-model="editedItem.xyear"
                  label="xyear"
                  return-object
                  item-text="name"
                  item-value="id"
                />
              </v-col> -->

              <v-col cols="6">
                <v-select
                  :items="xyears"
                  v-model="editedItem.xyear"
                  label="Xичээлийн жил"
                  return-object
                  item-text="name"
                  item-value="id"
                />
              </v-col>
              <v-col
                cols="6"
                v-if="editedItem.xyear && editedItem.xyear.semesters"
              >
                <v-select
                  :items="editedItem.xyear.semesters"
                  v-model="editedItem.semester"
                  label="semester"
                  return-object
                  item-text="shortName"
                  item-value="id"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container>
            <span class="red--text">{{ this.messageNotification }}</span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_close"> Цуцлаx </v-btn>
          <v-btn
            color="blue darken-1"
            @click="_save"
            dark
            class="text-capitalize"
          >
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import LessonTable from "@/views/lessons/LessonTable.vue";
import moment from "moment";
import { runInThisContext } from "vm";
import { userInfo } from "os";
export default {
  props: {},
  data() {
    return {
      errorMessage: null,
      messageNotification: null,
      newScoreDialog: false,
      editedItem: null,
      editedItemIndex: -1,
      studentScores: null,
      selectedSemester: null,
      classInfo: null,
      userData: null,
    };
  },
  props: {
    studentPath: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    selectedItems: function () {
      if (this.selectedSemester != null) {
        return this.studentScores;
        // return this.studentScores.filter(
        //   (item) =>
        //     item.department &&
        //     item.department.ref.path === this.selectedDepartment.ref.path
        // );
      } else {
        return this.studentScores;
      }
    },
  },
  async created() {
    var student = await fb.db.doc(this.studentPath).get();
    this.userData = student.data();
    this.userData.ref = student.ref;
    this.userData.id = student.id;
    this.userData.ref.get().then(async (student) => {
      var yy = await student.data();
      if (
        yy &&
        yy["xClassGroupProgramRef-2022-2023-1"] &&
        yy["xClassGroupProgramRef-2022-2023-1"]
      ) {
        yy["xClassGroupProgramRef-2022-2023-1"].get().then((doc) => {
          let classInfo = doc.data();
          classInfo.ref = doc.ref;
          classInfo.id = doc.id;
          this.classInfo = classInfo;
        });
      } else {
        if (
          yy &&
          yy["xClassGroupProgram-2022-2023-1"] &&
          yy["xClassGroupProgram-2022-2023-1"].ref
        ) {
          yy["xClassGroupProgram-2022-2023-1"].ref.get().then((doc) => {
            let classInfo = doc.data();
            classInfo.ref = doc.ref;
            classInfo.id = doc.id;
            this.classInfo = classInfo;
          });
        }
      }
    });
    this._searchStudentScore(this.userData.studentCode);
    fb.db
      .collection(fb.yyschool + "/xschoolyears")
      .get()
      .then((docs) => {
        this.xyears = [];
        docs.forEach((doc) => {
          let xyear = doc.data();
          xyear.ref = doc.ref;
          xyear.id = doc.id;
          xyear.semesters = null;
          doc.ref
            .collection("semesters")
            .get()
            .then((docs) => {
              xyear.semesters = [];
              docs.forEach((doc) => {
                let semester = doc.data();
                semester.ref = doc.ref;
                semester.id = doc.id;
                xyear.semesters.push(semester);
              });
            });
          this.xyears.push(xyear);
        });
      });

    //  fb.db
    // .collection(fb.yyschool + "/xschoolyears/RpcsCGiicGrTjdM5SFHc/semesters")
    // .orderBy("createdAt", "desc")
    // .get()
    // .then((querySnapshot) => {
    //   {
    //     this.semesters = [];
    //     querySnapshot.forEach((doc) => {
    //       let semester = doc.data();
    //       semester.id = doc.id;
    //       semester.ref = doc.ref;
    //       semester.name =
    //         semester.startDate +
    //         " / " +
    //         semester.endDate +
    //         " /" +
    //         semester.code +
    //         "/";

    //       });
    //       if (this.selectedSemester == null && semester) {
    //         this.selectedSemester = semester;
    //       }
    //       this.semesters.push(semester);
    //     });
    //   }
    // });
  },
  methods: {
    _editScore(item) {
      console.log(item.ref.path);
      this.editedItem = item;
      this.newScoreDialog = true;
    },
    _searchStudentScore(studentCode) {
      fb.db
        .collectionGroup("yearScores")
        .where("studentCode", "==", studentCode)
        .onSnapshot((querySnapshot) => {
          this.studentScores = [];
          querySnapshot.forEach(async (doc) => {
            let score = doc.data();
            score.ref = doc.ref;
            score.id = doc.id;
            var datas = await fb.db
              .collection("/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/")
              .where("code", "==", score.lessonCode)
              .limit(1)
              .get();
            if (!datas.empty) {
              var doc = datas.docs[0];
              if (doc != null && doc.exists) {
                score.lesson = doc.data();
              }
            } else {
              var datas = await fb.db
                .collection("/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/")
                .where("code", "==", score.lessonCode.toUpperCase())
                .limit(1)
                .get();
              if (!datas.empty) {
                var doc = datas.docs[0];
                if (doc != null && doc.exists) {
                  score.lesson = doc.data();
                }
              }
            }
            this.studentScores.push(score);
          });
          // if (querySnapshot.empty) {
          //   this.errorMessage = "No Score!";
          // }

          //additional code
          // this.userData.ref
          //   .collection("scores")
          //   .get()
          //   .then((docs) => {
          //     docs.forEach((doc) => {
          //       let score1 = doc.data();
          //       score1.id = doc.id;
          //       score1.ref = doc.ref;
          //       this.studentScores.push(score1);
          //     });
          //   });
          fb.db
            .collectionGroup("yearScores")
            .where("studentDocId", "==", this.userData.ref.id)
            .onSnapshot((querySnapshot) => {
              querySnapshot.forEach(async (doc) => {
                let score = doc.data();
                score.ref = doc.ref;
                score.id = doc.id;
                var datas = await fb.db
                  .collection(
                    "/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/"
                  )
                  .where("code", "==", score.lessonCode)
                  .limit(1)
                  .get();
                if (!datas.empty) {
                  var doc = datas.docs[0];
                  if (doc != null && doc.exists) {
                    score.lesson = doc.data();
                  }
                } else {
                  // this.accessOK = false
                }
                this.studentScores.push(score);
              });
            });
        });
    },
    _deleteScore(score) {
      var yes = confirm("Delete?");
      if (yes) {
        score.ref.delete();
      }
    },
    _addScore() {
      this.editedItem = { lessonCode: null };
      this.editedItemIndex = -1;
      this.newScoreDialog = true;
    },
    _close() {
      this.newScoreDialog = false;
      this.editedItem = null;
      this.editedItemIndex = -1;
    },
    async _save() {
      if (
        this.editedItem.score30 > 0 &&
        this.editedItem.score70 > 0 &&
        this.editedItem.xyear &&
        this.editedItem.lessonCode
      ) {
        console.log(this.editedItem.xyear, this.editedItem.semester.code);
        var score = {
          score30: this.editedItem.score30,
          score70: this.editedItem.score70,
          semester: this.editedItem.semester.code,
          semesterName: this.editedItem.semester.code == 1 ? "Намар" : "Xавар",
          schoolYear:
            this.editedItem.xyear.startYear +
            "-" +
            this.editedItem.xyear.endYear,
          xyear: this.editedItem.xyear.name,
          lessonCode: this.editedItem.lessonCode.toLowerCase(),
          scoreTotal: this.editedItem.score30 + this.editedItem.score70,
          scoredBy: this.userProfile.firstName
            ? this.userProfile.firstName
            : null,
          scoredByEmail: this.userProfile.email ? this.userProfile.email : null,
          scoredAt: new Date(),
          studentCode: this.userData.studentCode,
        };
        // score.enteredBy = this.userProfile
        // score.enteredAt = new Date()
        var path =
          "schools/YJHjHWUGDok8teDhDIKX/_allStudentsScores/" +
          score.schoolYear +
          "-" +
          score.semester +
          "/yearScores/" +
          this.userData.studentCode +
          "-" +
          this.editedItem.lessonCode;

        // if (score.lessonCode) {
        //     var datas = await fb.db
        //       .collection("/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/")
        //       .where("code", "==", score.lessonCode)
        //       .limit(1)
        //       .get();
        //     if (!datas.empty) {
        //       var doc = datas.docs[0];
        //       if (doc != null && doc.exists) {
        //         score.lesson = doc.data();
        //       }
        //     } else {
        //       var datas = await fb.db
        //         .collection(
        //           "/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/"
        //         )
        //         .where("code", "==", score.lessonCode.toUpperCase())
        //         .limit(1)
        //         .get();
        //       if (!datas.empty) {
        //         var doc = datas.docs[0];
        //         if (doc != null && doc.exists) {
        //           score.lesson = doc.data();
        //         }
        //       }
        //     }
        //   }

        fb.db
          .doc(path)
          .set(score, { merge: true })
          .then(() => {
            this._close();
          });
      }
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>
